import type { BoxProps } from '../Box/Box';
import { Box } from '../Box/Box';

import * as styles from './styles.css';

export type Props = React.PropsWithChildren & styles.Variants & { cssClass?: string; width?: BoxProps['width'] };

export const Card: React.FC<Props> = ({ children, cssClass, width, ...rest }) => (
  <Box cssClass={[styles.variants({ ...rest }), cssClass]} width={width}>
    {children}
  </Box>
);
